/* eslint-disable */
import React, { useEffect, useState } from "react";
import RenderHome from "../home/RenderHome";
import { useDispatch, useSelector } from "react-redux";
import { GetUserProfile } from "../../../service/action-creators/authAction";
import { ToastContainer, toast } from "react-toastify";
import axiosInstance from "../../../service/axios/axios";
import { useHistory } from "react-router-dom";

function RequestSettlement() {
  const dispatch = useDispatch();
  const history = useHistory();
  const auth = useSelector((state) => state?.auth);
  const user = auth?.user;

  const [formData, setFormData] = useState({
    email: "",
    phone: "",
    id_card: "",
  });
  const [formError, setFormError] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    dispatch(GetUserProfile());
  }, []);

  useEffect(() => {
    if (user) {
      setFormData((prev) => ({
        ...prev,
        email: user.email || "",
        phone: user.phone_number || "",
      }));
    }
  }, [user]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setFormError({ ...formError, [e.target.name]: "" });
  };

  const validate = () => {
    const err = {};
    if (!formData.email) err.email = "Email is required";
    if (!formData.phone) err.phone = "Phone number is required";
    if (!formData.id_card) err.id_card = "Identification card number is required";
    setFormError(err);
    return Object.keys(err).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setIsLoading(true);
    try {
      await axiosInstance.post("/settlement/request", {
        email: formData.email,
        phone: formData.phone,
        id_card: formData.id_card,
      });
      toast.success("Settlement request submitted successfully!");
      setTimeout(() => history.push("/my-settlement-quotation"), 1500);
    } catch (err) {
      toast.error(
        err?.response?.data?.message || "Failed to submit. Try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <RenderHome>
      <ToastContainer />
      <div style={{ maxWidth: 600, margin: "0 auto", padding: "24px 16px" }}>
        <div
          style={{
            background: "#fff",
            borderRadius: 12,
            boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
            overflow: "hidden",
          }}
        >
          {/* Header */}
          <div
            style={{
              background: "#2d6a4f",
              padding: "20px 28px",
              color: "#fff",
            }}
          >
            <h2 style={{ margin: 0, fontSize: 20, fontWeight: 700 }}>
              Request Settlement Quotation
            </h2>
            <p style={{ margin: "6px 0 0", fontSize: 13, opacity: 0.85 }}>
              Fill in the form below to request an outright loan settlement quote.
            </p>
          </div>

          {/* Staff ID (auto-filled, read-only) */}
          <div style={{ padding: "24px 28px 0" }}>
            <div style={{ marginBottom: 16 }}>
              <label style={labelStyle}>Staff ID</label>
              <input
                style={{ ...inputStyle, background: "#f5f5f5", color: "#666" }}
                value={user?.staff_id || ""}
                readOnly
              />
            </div>

            <form onSubmit={handleSubmit}>
              {/* Email */}
              <div style={{ marginBottom: 16 }}>
                <label style={labelStyle}>Email Address *</label>
                <input
                  style={inputStyle}
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter your email"
                />
                {formError.email && <span style={errorStyle}>{formError.email}</span>}
              </div>

              {/* Phone */}
              <div style={{ marginBottom: 16 }}>
                <label style={labelStyle}>Phone Number *</label>
                <input
                  style={inputStyle}
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Enter your phone number"
                />
                {formError.phone && <span style={errorStyle}>{formError.phone}</span>}
              </div>

              {/* ID Card */}
              <div style={{ marginBottom: 24 }}>
                <label style={labelStyle}>Identification Card Number *</label>
                <input
                  style={inputStyle}
                  type="text"
                  name="id_card"
                  value={formData.id_card}
                  onChange={handleChange}
                  placeholder="GHA-12xxxxxxxxx-10"
                />
                {formError.id_card && (
                  <span style={errorStyle}>{formError.id_card}</span>
                )}
              </div>

              <button
                type="submit"
                disabled={isLoading}
                style={{
                  width: "100%",
                  padding: "13px",
                  background: isLoading ? "#aaa" : "#2d6a4f",
                  color: "#fff",
                  border: "none",
                  borderRadius: 8,
                  fontSize: 15,
                  fontWeight: 700,
                  cursor: isLoading ? "not-allowed" : "pointer",
                  marginBottom: 24,
                }}
              >
                {isLoading ? "Submitting..." : "Request Settlement"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </RenderHome>
  );
}

const labelStyle = {
  display: "block",
  fontSize: 13,
  fontWeight: 600,
  color: "#333",
  marginBottom: 6,
};

const inputStyle = {
  width: "100%",
  padding: "10px 12px",
  border: "1px solid #ddd",
  borderRadius: 6,
  fontSize: 14,
  outline: "none",
  boxSizing: "border-box",
};

const errorStyle = {
  color: "#e53935",
  fontSize: 12,
  marginTop: 4,
  display: "block",
};

export default RequestSettlement;
